module.exports = __webpack_public_path__ + "static/media/6.4017180f.svg";